import { useFeatureFlagEnabled } from '@posthog/react';

/**
 * Ambiente de deploy usado para isolar feature flags no mesmo projeto PostHog.
 * Valores esperados: `homolog` | `production`
 *
 * No PostHog, crie sempre o par de flags, ex.:
 * - download-comprovante-segmento-z-homolog
 * - download-comprovante-segmento-z-production
 */
export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'homolog';

/**
 * @param {string} flagKey chave base (sem ambiente), ex.: FEATURE_FLAGS.DOWNLOAD_COMPROVANTE_SEGMENTO_Z
 * @returns {boolean | undefined} `true` when enabled; `undefined` while unknown/loading
 */
export function useFeatureFlag(flagKey) {
  const resolvedFlagKey = flagKey ? `${flagKey}-${APP_ENVIRONMENT}` : flagKey;
  return useFeatureFlagEnabled(resolvedFlagKey);
}
